export default "__VITE_ASSET__DdEgYpIh__"